import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const baseUrl = 'https://quiz-laura-default-rtdb.firebaseio.com'
const createRequest = (url) => ({ url, headers: new Headers()})

export const questionsApi = createApi({
    reducerPath: 'questionsApi',
    baseQuery: fetchBaseQuery({ baseUrl }),
    endpoints: (builder) => ({
        getQuestions: builder.query({
            query: () => createRequest('/questions-laura.json'),
        })
    })
});

export const { useGetQuestionsQuery } = questionsApi;